export default __webpack_public_path__ + "2f2088c31e49792b9834dea77e85317a.png";